import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
}
export function AccordionItem({
  question,
  answer
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-167">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-4 px-2 flex items-center justify-between text-left hover:bg-gray-50 transition-colors rounded-lg" data-id="element-168">
        <span className="font-bold text-gray-800 text-lg" data-id="element-169">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-170">
          <ChevronDown className="w-5 h-5 text-blue-600" data-id="element-171" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-172">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="overflow-hidden" data-id="element-173">
            <div className="pb-4 px-2 text-gray-600 leading-relaxed" data-id="element-174">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}